






































import { computed, defineComponent, ref } from '@vue/composition-api'
import { getSectionErrors } from '@/composable/validator/utils'
import { useSettings } from '@/composable/repositories/useSettings'
import { useTranslationLanguages } from '@/composable/repositories/useTranslationLanguages'
import type { GeneralSettingsLocale } from '@futureecom/futureecom-js/dist/services/setting-service'
import type { PropType } from '@vue/composition-api'
import type { ValidationErrors } from '@/types/validator'

export default defineComponent({
  name: 'TranslationTabs',

  props: {
    translatableValues: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    errors: {
      type: Object as PropType<ValidationErrors>,
      default: () => ({})
    }
  },

  setup(props) {
    const tab = ref(0)

    const { translationLanguages } = useTranslationLanguages()
    const { getSettings } = useSettings()
    const defaultLanguage = getSettings<GeneralSettingsLocale['language']>('general.locale.language').value || ''

    const getSlotName = (code: string, translatableValue: string): string => {
      return code === defaultLanguage ? `default.${translatableValue}` : translatableValue
    }

    const languageTabs = computed(() => [
      { code: defaultLanguage, flag: '', name: 'default' },
      ...translationLanguages.value.filter((item) => item.code !== defaultLanguage)
    ])

    const tabErrors = computed(() => {
      const tabs = translationLanguages.value.reduce((prev, current) => {
        const code = current.code.toLowerCase()
        const translationFields = props.translatableValues.map((val) => {
          return code === defaultLanguage ? val : `translations.${code}.${val}`
        })

        return { ...prev, [current.code.toLowerCase()]: translationFields }
      }, {})

      return getSectionErrors(tabs, props.errors)
    })

    const lowerCased = (val: unknown) => computed((): string => `${val}`.toLowerCase())

    return {
      languageTabs,
      tab,
      tabErrors,
      getSlotName,
      lowerCased
    }
  }
})
